import { render, staticRenderFns } from "./SelectGroupsItems.vue?vue&type=template&id=6596c01a"
import script from "./SelectGroupsItems.vue?vue&type=script&lang=js"
export * from "./SelectGroupsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports